module.exports = __webpack_public_path__ + "img/btn_keep.316afc48.svg";